
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["loadModel","disposeModel","predict"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "6571198f39ddfec43afb.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			